import { useCallback } from "react";
import { VMS_CLICK_EVENTS, VMS_SCREEN_IDS, useVMSClickLog } from "@/app/hooks/useVMSClickLog";
import { useModalActions } from "./useModalActions";

/**
 * Single logout click handler shared by the header and the sidebar so both
 * entry points log the same click event and open the same LOGOUT modal.
 */
export const useLogoutAction = () => {
  const { setVisible } = useModalActions("LOGOUT");
  const { logVMSClick } = useVMSClickLog(VMS_SCREEN_IDS.HEADER);

  return useCallback(() => {
    logVMSClick(VMS_CLICK_EVENTS.HEADER_LOGOUT_CLICK, "Logout");
    setVisible();
  }, [logVMSClick, setVisible]);
};
